export default function AssessmentThreatsDirective() {
  return {
    template: require('./assessment-threats.html'),
    scope: {
      threatOptions: '=',
      assessmentThreats: '=',
    },
    controller: () => { /* 'AssessmentThreatsController' */ },
    controllerAs: 'assessmentThreatsVM',
    bindToController: true,
    replace: true,
  };
}
